import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getWorkDashboard, updateWorkRequest } from '../lib/work';
import type { TenantWorkDashboardResponse, TenantWorkRequestUpdatePayload } from '../types';

export const workKeys = {
  all: ['work'] as const,
  dashboard: () => [...workKeys.all, 'dashboard'] as const,
};

export function useTenantWorkDashboard(enabled: boolean = true) {
  return useQuery<TenantWorkDashboardResponse>({
    queryKey: workKeys.dashboard(),
    queryFn: getWorkDashboard,
    staleTime: 60 * 1000,
    retry: false,
    enabled,
  });
}

export function useUpdateTenantWorkRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ requestId, payload }: { requestId: number; payload: TenantWorkRequestUpdatePayload }) =>
      updateWorkRequest(requestId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workKeys.dashboard() });
    },
  });
}
